// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "loader_spinner-3VxzT";
var _3 = "rotation-3m0Bj";
var _4 = "loader-16k87";
var _5 = "loader__content-jZmlM";
export { _1 as "__esModule", _2 as "loader_spinner", _3 as "rotation", _4 as "loader", _5 as "loader__content" }
export default { "__esModule": _1, "loader_spinner": _2, "rotation": _3, "loader": _4, "loader__content": _5 }
